import React from 'react';
import { translate } from 'react-i18next';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { generateHeader } from './Common';
import { output, signedCell } from 'lib/pdfs/signature';

import moment from 'moment';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

/**
 * Generic per-asset voucher ("Acciones" of the asset detail) as a pdfmake
 * document, so the signing modal reuses it. props: {asset, subcompany, t}.
 * The optional signature goes on the "Recibe" line (lib/pdfs/signature).
 */
export const unitaryVoucherDoc = async (props, signature) => {
  const header = await generateHeader(
    `${props.subcompany.name}\n ${props.t('asset_employeePDF.title')}`
  );
  var docDefinition = {
    content: [
      header,
      {
        margin: [0, 10, 0, 0],
        columnGap: 20,
        columns: [
          {
            width: '*',
            text: `${props.t('asset_employeePDF.employee')}: ${props.asset._employee.name} ${
              props.asset._employee.lastname
            }`,
            bold: true,
            style: 'textStyle',
          },
          {
            width: '100',
            text: `${props.t('asset_employeePDF.date')}: ${moment().format('DD/MM/YYYY')}`,
            style: 'textStyle',
          },
        ],
      },
      {
        text: props.asset._employee.position
          ? `${props.t('asset_employeePDF.position')}: ${props.asset._employee.position}`
          : null,
        style: 'textStyle2',
      },
      {
        text: props.asset._employee.key
          ? `${props.t('asset_employeePDF.id')}: ${props.asset._employee.key}`
          : null,
        style: 'textStyle2',
      },
      { text: `${props.t('asset_employeePDF.message.title')}`, style: 'textStyle' },

      {
        margin: [0, 20, 0, 0],
        table: {
          headerRows: 1,
          widths: ['*', 100, 100, 100, 90],
          body: [
            [
              {
                text: `${props.t('asset_employeePDF.table.number')}`,
                style: 'tableRow',
                bold: true,
                fontSize: 10,
              },
              {
                text: `${props.t('asset_employeePDF.table.name')}`,
                style: 'tableRow',
                bold: true,
                fontSize: 10,
              },
              {
                text: `${props.t('asset_employeePDF.table.brand')}`,
                style: 'tableRow',
                bold: true,
                fontSize: 10,
              },
              {
                text: `${props.t('asset_employeePDF.table.model')}`,
                style: 'tableRow',
                bold: true,
                fontSize: 10,
              },
              {
                text: `${props.t('asset_employeePDF.table.serie')}`,
                style: 'tableRow',
                bold: true,
                fontSize: 10,
              },
            ],
            [
              { text: props.asset.number, bold: true, style: 'tableRowOdd' },
              { text: props.asset.name, style: 'tableRowOdd' },
              { text: props.asset.brand, style: 'tableRowOdd' },
              { text: props.asset.model, style: 'tableRowOdd' },
              { text: props.asset.serie, style: 'tableRowOdd' },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return i === 0 || i === 1 ? 2 : 1;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return '#e9ecef';
          },
        },
      },
      {
        text: `${props.t('asset_employeePDF.message.content')}`,
        style: 'textStyle',
      },

      {
        margin: [0, 60, 0, 0],
        table: {
          headerRows: 0,
          widths: ['*', 200, '*'],
          body: [
            [
              { text: '', border: [false, false, false, false] },
              signedCell(
                {
                  text: `${props.asset._employee.name} ${
                    props.asset._employee.lastname
                  }\n ${props.t('asset_employeePDF.receive')}`,
                  style: 'tableRow',
                  bold: true,
                  fontSize: 10,
                  alignment: 'center',
                  border: [false, true, false, false],
                },
                signature
              ),
              { text: '', border: [false, false, false, false] },
            ],
          ],
        },
        layout: {
          hLineWidth: function (i, node) {
            return 1;
          },
          vLineWidth: function (i, node) {
            return 0;
          },
          hLineColor: function (i, node) {
            return '#45535b';
          },
        },
      },

      // {
      //   alignment: "center",
      //   text: `${props.t("asset_employeePDF.out.title")}`,
      //   bold: true,
      //   style: "textStyle"
      // },

      // {
      //   layout: "noBorders",
      //   margin: [0, 10, 0, 0],
      //   table: {
      //     headerRows: 1,
      //     widths: [100, 100, 100, 100, 90],
      //     body: [
      //       [
      //         { text: `${props.t("asset_employeePDF.out.date")}`, style: "tableRow", bold: true, fontSize: 10 },
      //         { text: `${props.t("asset_employeePDF.out.outDate")}`, style: "tableRow", bold: true, fontSize: 10 },
      //         { text: `${props.t("asset_employeePDF.out.max_time")}`, style: "tableRow", bold: true, fontSize: 10, alignment: "center" },
      //         { text: `${props.t("asset_employeePDF.out.outDays")}`, style: "tableRow", bold: true, fontSize: 10, alignment: "center" },
      //         { text: `${props.t("asset_employeePDF.out.isOut.title")}`, style: "tableRow", bold: true, fontSize: 10, alignment: "center" },
      //       ],
      //       [
      //         { text: props.asset.out === undefined ? "-" : props.asset.out.isOut === false ? "-" : moment(props.asset.out.createdAt).format("DD/MM/YYYY HH:mm:ss"), style: "tableRowOdd" },
      //         { text: props.asset.out === undefined ? "-" : props.asset.out.isOut === false ? "-" : moment(props.asset.out.outDate).format("DD/MM/YYYY HH:mm:ss"), style: "tableRowOdd" },
      //         { text: props.asset.out === undefined ? "-" : props.asset.out.isOut === false ? "-" : props.asset.out.max_time, style: "tableRowOdd", alignment: "center"},
      //         { text: props.asset.out === undefined ? "-" : props.asset.out.isOut === false ? "-" : diffDates(new Date(props.asset.out.outDate), new Date()), style: "tableRowOdd", alignment: "center" },
      //         { text: props.asset.out === undefined ? "-" : props.asset.out._user_authorized === undefined ?  props.t("asset_employeePDF.out.isOut.onHold") : props.asset.out.isOut === false ? props.t("asset_employeePDF.out.isOut.indoors") : props.t("asset_employeePDF.out.isOut.outside"), style: "tableRowOdd", alignment: "center" }
      //       ]
      //     ]
      //   }
      // },
      // {
      //   layout: "noBorders",
      //   margin: [0, 10, 0, 0],
      //   table: {
      //     headerRows: 1,
      //     widths: [100, 100, 100, 200],
      //     body: [
      //       [
      //         { text: `${props.t("asset_employeePDF.out.employee")}`, style: "tableRow", bold: true, fontSize: 10 },
      //         { text: `${props.t("asset_employeePDF.out.user_request")}`, style: "tableRow", bold: true, fontSize: 10 },
      //         { text: `${props.t("asset_employeePDF.out.user_authorized")}`, style: "tableRow", bold: true, fontSize: 10 },
      //         { text: `${props.t("asset_employeePDF.out.message")}`, style: "tableRow", bold: true, fontSize: 10 }
      //       ],
      //       [
      //         { text: `${props.asset.out === undefined ? "-" : props.asset.out.isOut === false ? "-" : props.asset.out._employee.name} ${ props.asset.out === undefined ? "" : props.asset.out.isOut === false ? "" : props.asset.out._employee.lastname}`, style: "tableRowOdd" },
      //         { text: `${props.asset.out === undefined ? "-" : props.asset.out.isOut === false ? "-" : props.asset.out._user_request.name} ${props.asset.out === undefined ? "" : props.asset.out.isOut === false ? "" : props.asset.out._user_request.lastname}`, style: "tableRowOdd"},
      //         { text: `${props.asset.out === undefined ? "-" : props.asset.out.isOut === false ? "-" : props.asset.out._user_authorized === undefined ?  "-" :  props.asset.out._user_authorized.name} ${props.asset.out === undefined ? "" : props.asset.out.isOut === false ? "" : props.asset.out._user_authorized === undefined ?  "" : props.asset.out._user_authorized.lastname} `, style: "tableRowOdd"},
      //         { text: props.asset.out === undefined ? "-" : props.asset.out.isOut === false ? "-" : props.asset.out.message, style: "tableRowOdd" }
      //       ]
      //     ]
      //   }
      // },

      // {
      //   alignment: "center",
      //   image: "qrURL",
      //   width: 120
      // }
    ],

    // images : {
    //   qrURL: props.asset.qrUrl
    // },

    styles: {
      textStyle: {
        color: '#45535b',
        fontSize: 11,
        margin: [0, 20, 0, 0],
      },
      textStyle2: {
        color: '#45535b',
        fontSize: 11,
        margin: [0, 0, 0, 0],
      },
      tableRow: {
        color: '#45535b',
        fontSize: 9,
        margin: [10, 5, 0, 5],
      },
      tableRowOdd: {
        color: '#45535b',
        fontSize: 9,
        fillColor: '#f4f4f4',
        margin: [10, 5, 0, 5],
      },
    },
  };
  return docDefinition;
};

export const generateUnitaryVoucherPDF = async (props, options = {}) =>
  output(await unitaryVoucherDoc(props, options.signature), options, { inBlock: true });

const PDFassetDetailUnitario = (props) => {
  const diffDates = (date1, date2) => {
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) - 1 + '';
    return diffDays;
  };

  async function handleSubmit(e) {
    e.preventDefault();
    await generateUnitaryVoucherPDF(props);
  }
  return (
    <a className="btn btn-sm btn-outline-primary w-100 my-1" href="#export" onClick={handleSubmit}>
      {props.t('actions.exportPDF')}
    </a>
  );
};

export default translate()(PDFassetDetailUnitario);



// WEBPACK FOOTER //
// src/lib/pdfs/EmployeesAssetUnitarioPDF.js